// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_2a1Mz","title":"index_title_3mk0x","time":"index_time_6Szsy","content":"index_content_-KqWW","tabs":"index_tabs_3BVXH"};